import React, { Component } from 'react';
import { Layout } from 'antd';

import StrikeFooter from '../../components/StrikeFooter';
import { getLogoDark } from '../../utils/BrandConfig';
import { useBrandProduct } from '../../contexts/BrandContext';

import 'antd/dist/antd.css';
import '../../App.scss';

const { Header, Content } = Layout;

// Logo dimensions: striketip 657x120, strikepay 845x244. For 180px width, heights differ.
const LOGO_WIDTH = 180;
const LOGO_HEIGHT_BY_BRAND = { striketip: 33, strikepay: 52 }; // height when width=180
const HEADER_MIN_HEIGHT = 56; // fits taller strikepay logo

function ClaimLayoutContent({ children, locStrings }) {
  const { brand } = useBrandProduct();
  const logo = getLogoDark(brand);
  const logoHeight = LOGO_HEIGHT_BY_BRAND[brand] || LOGO_HEIGHT_BY_BRAND.striketip;
  return (
    <Layout
      className="layout"
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Header
        className="top"
        style={{
          backgroundColor: '#000000',
          width: '100%',
          minWidth: '300px',
          minHeight: HEADER_MIN_HEIGHT,
          flexShrink: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          src={logo}
          style={{ height: logoHeight, width: LOGO_WIDTH, objectFit: 'contain' }}
          alt="Home"
        />
      </Header>
      <Content
        style={{
          padding: 0,
          margin: 0,
          width: '100%',
          flex: '1 1 auto',
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          className="site-layout-content"
          style={{
            width: '100%',
            padding: 0,
            margin: 0,
            flex: '1 1 auto',
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {children}
        </div>
      </Content>
      <div style={{ flexShrink: 0 }}>
        <StrikeFooter locStrings={locStrings} />
      </div>
    </Layout>
  );
}

export default class ClaimLayout extends Component {
  render() {
    return (
      <ClaimLayoutContent locStrings={this.props.locStrings}>
        {this.props.children}
      </ClaimLayoutContent>
    );
  }
}